import { RootState } from "store/index";

const selectRightPanelState = (state: RootState) => state.rightPanel;

const selectCurrentPollTab = (state: RootState) => state.rightPanel.pollsTabId;

export { selectRightPanelState, selectCurrentPollTab };
